import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { PortfolioProvider } from 'Components/UI/Portfolio/PortfolioContext';

import Holdings from 'Components/UI/Snapshot/Holdings';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const SnapshotHoldings = withStyles({
  root: {
    contentVisibility: 'auto',
    width: 'unset',
    maxWidth: 'unset',
    flexWrap: 'nowrap',
  },
  content: {
    maxWidth: '100%',
  },
  list: {
    minWidth: 'unset',
  },
  chart: {
    alignSelf: 'flex-start',
    justifySelf: 'flex-start',
    width: 400,
  },
})(Holdings);

const View = ({ className, classes }) => {
  const { householdResource } = useSimpleHousehold();

  const portfolioRel = householdResource
    ?.relationship('portfolio')
    .link('related');

  return (
    <PortfolioProvider portfolioRelationship={portfolioRel}>
      <SnapshotHoldings className={classNames(classes.root, className)} />
    </PortfolioProvider>
  );
};

View.defaultProps = {
  className: '',
};

View.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles({ root: {} })(View);
